/* @ngInject */
class Preferences {
	constructor(localStorageService) {
		this.DEFAULT_DATE_FORMAT = 'DD/MM/YYYY';
		this.DEFAULT_TIME_FORMAT = 'HH:mm:ss Z';
		this.DEFAULT_TIME_ORDER  = 'Date then Time';

		this.localStorageService = localStorageService;
	}

	setDateTimePreference(date, time, order) {
		this.localStorageService.set('preferences.dateFormat', date);
		this.localStorageService.set('preferences.timeFormat', time);
		this.localStorageService.set('preferences.order', order);
	}

	getDateFormatList() {
		return [
			{
				type:  'Day / Month / Year',
				dates: [
					'DD/MM/YY',
					'DD-MM-YY',
					'DD MM YY',

					'DD/MM/YYYY',
					'DD-MM-YYYY',
					'DD MM YYYY',

					'Do/MMM/YYYY',
					'Do-MMM-YYYY',
					'Do MMM YYYY',

					'Do/MMMM/YYYY',
					'Do-MMMM-YYYY',
					'Do MMMM YYYY',
				],
			},
			{
				type:  'Month / Day / Year',
				dates: [
					'MM/DD/YY',
					'MM-DD-YY',
					'MM DD YY',

					'MM/DD/YYYY',
					'MM-DD-YYYY',
					'MM DD YYYY',

					'MMM/Do/YYYY',
					'MMM-Do-YYYY',
					'MMM Do YYYY',

					'MMMM/Do/YYYY',
					'MMMM-Do-YYYY',
					'MMMM Do YYYY',
				],
			},
			{
				type:  'Year / Month / Day',
				dates: [
					'YY/MM/DD',
					'YY-MM-DD',
					'YY MM DD',

					'YYYY/MM/DD',
					'YYYY-MM-DD',
					'YYYY MM DD',

					'YYYY/MMM/Do',
					'YYYY-MMM-Do',
					'YYYY MMM Do',

					'YYYY/MMMM/Do',
					'YYYY-MMMM-Do',
					'YYYY MMMM Do',
				],
			},
		];
	}

	getTimeFormatList() {
		return [
			{
				type:  'Display seconds',
				times: [
					'HH:mm:ss Z',
					'h:mm:ss A Z',
					'h:mm:ss a Z',
				],
			},
			{
				type:  'Hide seconds',
				times: [
					'HH:mm Z',
					'h:mm A Z',
					'h:mm a Z',
				],
			},
		];
	}

	getDateTimeFormatList() {
		return [
			'Date then Time',
			'Time then Date',
		];
	}

	getDateTimePreference() {
		let date  = this.localStorageService.get('preferences.dateFormat');
		let time  = this.localStorageService.get('preferences.timeFormat');
		let order = this.localStorageService.get('preferences.order');

		if (!date) {
			date = this.DEFAULT_DATE_FORMAT;
		}

		if (!time) {
			time = this.DEFAULT_TIME_FORMAT;
		}

		if (!order) {
			order = this.DEFAULT_TIME_ORDER;
		}

		return {
			date:  date,
			time:  time,
			order: order,
		};
	}
}

export default Preferences;


// WEBPACK FOOTER //
// ./src/js/services/preferences/index.js